import Header from "@components/Account/Layout/Header/Header";
import SubHeader from "@components/Account/Layout/Header/SubHeader";
import { ProfileScreenRoute } from "@components/Account/Layout/utils";
import LBox from "@components/LBox";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";

type HeaderGroupProps = {
  routes: ProfileScreenRoute[];
};

const HeaderGroup = ({ routes }: HeaderGroupProps) => {
  const pathName = useNavigationStore((state) => state.currentPath);
  const activeRoute = routes.find((item) =>
    pathName.includes(item.activePathName),
  );

  return (
    <LBox>
      <Header routes={routes} />
      {activeRoute?.subRoutes ? (
        <LBox mb="s2" mt="s4">
          <SubHeader routes={activeRoute.subRoutes} />
        </LBox>
      ) : null}
    </LBox>
  );
};

export default HeaderGroup;
